/**
   * 指定箇所をAjaxリロードする
   * @param url {string} 取得先のURL
   * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
   * @param to {string} 取得先のセレクタ　,区切りで複数指定

   */
window.ajaxUpdate = function (url, from, to) {
  let ajax = false

  const method = 'get'
  from = from.split(',') // ,区切りで配列に変換
  to = to.split(',') // ,区切りで配列に変換

  const loadingItem = document.createElement('div')
  loadingItem.className = 'md-loading active'

  // ローディング処理
  for (let index = 0; index < to.length; index++) {
    const itemTo = document.querySelector(to[index])
    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'

    loadingItem.style.width = itemTo.offsetWidth + 'px'
    loadingItem.style.height = itemTo.offsetHeight + 'px'
    itemTo.innerHTML = ''

    itemTo.appendChild(loadingItem)
  }

  ajax = new XMLHttpRequest() // Ajaxリクエスト

  // Ajaxと明示するパラメータを付ける
  url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
  ajax.open(method, url, true) // GET/POST, URL, 非同期処理

  ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
  // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
  // ajax.setRequestHeader('Pragma', 'no-cache')
  // ajax.setRequestHeader('Cache-Control', 'no-cache')
  // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')

  ajax.responseType = 'document' // 取得タイプ document text json
  ajax.timeout = 10000 // タイムアウト判定時間
  ajax.send() // GETリクエスト実行
  ajax.onload = function () {
    // アクセス成功
    if (ajax.status < 200 || ajax.status >= 400) {
      console.log('Error: Code ' + ajax.status) // エラー
      return
    }

    const ajaxData = ajax.response // 取得データ

    for (let index = 0; index < to.length; index++) {
      const itemFrom = ajaxData.querySelector(from[index])
      const itemTo = document.querySelector(to[index])

      itemTo.innerHTML = itemFrom.innerHTML
    }
  }
  ajax.ontimeout = function (e) {
    // タイムアウト
  }
  ajax.onerror = function () {
    // Ajax処理失敗
  }
  ajax.onloadend = function () {
    // 受信成否に関わらず実行
  }
}
